import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { apiConfig } from "../constants/apiConfig";
import UserProfile from "./userProfile";
import { UserRole } from "../constants/RoleEnum";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../constants/routerUrl";
import StaffCampusSafetyAlert from "../pages/staff/navbar/components/staffCampusSafetyAlert";
import { baseURL, suiteType } from "../constants/commonConstants";
import SweetAlert from "react-bootstrap-sweetalert";
import { emailBlockId } from "../constants/pageBlocks";
import { setToMailId } from "../store/slices/common/commonSlice";
import { getToMailId } from "../action/common/commonActionCreator";
import SearchWithAI from "../common-components/searchWithAI/searchWithAI";
import { getNotificationCount } from "../action/masters/notificationActionCreator";

const Header = (props: any) => {
  const navigate = useNavigate();
  const {
    currentRole,
    notViewedCount,
    freshman,
    user,
    getToMailId,
    toMailId,
    getNotificationsCount,
  } = props;
  const [suite] = useState<suiteType>(apiConfig.suite as suiteType);
  const [mail, setMail] = useState<string|undefined>("");
  const [showUser, setShowUser] = useState<boolean>(false);
  const [show, setShow] = useState(false);
  const [count, setCount] = useState<number>(0);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("");
  const [alertTitle, setAlertTitle] = useState<any>("");
  const [isActive, setIsActive] = useState(false);
  const userProfileRef = useRef<HTMLDivElement | null>(null);
  const safetyAlertRef = useRef<HTMLDivElement | null>(null);
  const navRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (suite == suiteType.google)
      setMail(apiConfig.gmailBaseUrl)
    else if(suite == suiteType.microsoft)
      setMail(apiConfig.outlookMailBaseUrl)
  },[])

  const toggleSafetyAlert = (e: React.MouseEvent) => {
    e.stopPropagation();

    setShow((prev) => !prev);
    if (showUser) setShowUser(false);
  };

  const toggleUserProfile = (e: React.MouseEvent) => {
    e.stopPropagation();

    setShowUser((prev) => !prev);
    if (show) setShow(false);
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setShow(false);
      setShowUser(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleCountChange = (newCount: number) => {
    setCount(newCount);
  };

  useEffect(() => {
    getToMailId(emailBlockId.Campus_Safety);
    return () => {
      dispatch(setToMailId([]));
    };
  }, []);

  useEffect(() => {
    if (
      currentRole !== UserRole.SuperAdmin &&
      currentRole !== UserRole.CollegeAdmin &&
      currentRole !== UserRole.DepartmentAdmin &&
      currentRole !== null
    ) {
      getNotificationsCount();
    }
  }, [currentRole]);

  const renderHeader = () => {
    const basePath = location.pathname;
    switch (currentRole) {
      case UserRole.SuperAdmin:
        return "Super Admin Portal";
      case UserRole.CollegeAdmin:
        return "University Management Admin Portal";
      case UserRole.DepartmentAdmin:
        return "Department Admin Portal";
      case UserRole.Staff:
        return basePath.startsWith(ROUTER_URL.STAFF_DASHBOARD)
          ? "Staff Dashboard"
          : "Staff Portal";
      case UserRole.Faculty:
        return basePath.startsWith(ROUTER_URL.FACULTY_DASHBOARD)
          ? "Faculty Dashboard"
          : "Faculty Portal";
      case UserRole.Student:
        return freshman && !user.isCourseStarted
          ? "Freshman Process"
          : basePath.startsWith(ROUTER_URL.STUDENT_DASHBOAD)
            ? "Student Dashboard"
            : "Student Portal";
      default:
        return "Portal";
    }
  };

  const handleClick = () => {
    const nav = document.querySelector("nav");
    if (nav) {
      nav?.classList.toggle("active");
      setIsActive(!isActive);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(event.target as Node)) {
        const mainElement = (event.target as HTMLElement).closest("main");
         const naveElement = mainElement?.querySelector("nav");
        if (naveElement) {
          naveElement.classList.remove("active");
        }
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [navRef]);

  useEffect(() => {
    const menuItems = document.querySelectorAll("nav ul li");
    menuItems.forEach((item) => {
      item.addEventListener("click", () => {
        const nav = document.querySelector("nav");
        if (nav) {
          nav.classList.remove("active");
          setIsActive(false);
        }
      });
    });

    return () => {
      menuItems.forEach((item) => {
        item.removeEventListener("click", () => { });
      });
    };
  }, []);

  return (
    <>
      <header ref={navRef}>
        <div className="burger-menu" onClick={handleClick}>
         <span></span>
         <span></span>
         <span></span>
        </div>
        <h1>{renderHeader()}</h1>
        <div className="right-wrap">
          {(currentRole === UserRole.Staff || currentRole === UserRole.Faculty || (currentRole === UserRole.Student && !freshman)) && <SearchWithAI />}
          <ul className="btn-notify">
            <li className="email">
              <a
                href={
                  currentRole === UserRole.SuperAdmin ||
                    currentRole === UserRole.CollegeAdmin ||
                    currentRole === UserRole.DepartmentAdmin ||
                    currentRole === UserRole.Staff ||
                    currentRole === UserRole.Faculty
                    ? mail
                    : undefined
                }
                title="Send Email"
                target={
                  currentRole === UserRole.SuperAdmin ||
                    currentRole === UserRole.CollegeAdmin ||
                    currentRole === UserRole.DepartmentAdmin ||
                    currentRole === UserRole.Staff ||
                    currentRole === UserRole.Faculty
                    ? "_blank"
                    : "_self"
                }
                onClick={
                  currentRole === UserRole.Student
                    ? () => navigate(ROUTER_URL.STUDENT_SENDTOMAIL)
                    : undefined
                }
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
                    stroke="#50306D"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                    stroke="#50306D"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li>
            {(currentRole === UserRole.Staff ||
              (currentRole === UserRole.Student && user?.isCourseStarted) ||
              currentRole === UserRole.Faculty) && (
                <>
                  <li
                    className="safety"
                    title="Safety Alert"
                    style={{
                      pointerEvents: toMailId ? "auto" : "none",
                      opacity: toMailId ? 1 : 0.5,
                    }}
                  >
                    <a href="javascript:void(0)" onClick={toggleSafetyAlert}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.0206 2.91003C8.71058 2.91003 6.02058 5.60003 6.02058 8.91003V11.8C6.02058 12.41 5.76058 13.34 5.45058 13.86L4.30058 15.77C3.59058 16.95 4.08058 18.26 5.38058 18.7C9.69058 20.14 14.3406 20.14 18.6506 18.7C19.8606 18.3 20.3906 16.87 19.7306 15.77L18.5806 13.86C18.2806 13.34 18.0206 12.41 18.0206 11.8V8.91003C18.0206 5.61003 15.3206 2.91003 12.0206 2.91003Z"
                          stroke="#BF5832"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                        <path
                          d="M13.8699 3.2C13.5599 3.11 13.2399 3.04 12.9099 3C11.9499 2.88 11.0299 2.95 10.1699 3.2C10.4599 2.46 11.1799 1.94 12.0199 1.94C12.8599 1.94 13.5799 2.46 13.8699 3.2Z"
                          stroke="#BF5832"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.0195 19.06C15.0195 20.71 13.6695 22.06 12.0195 22.06C11.1995 22.06 10.4395 21.72 9.89953 21.18C9.35953 20.64 9.01953 19.88 9.01953 19.06"
                          stroke="#BF5832"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                        />
                      </svg>
                      <span className="notification-count">{count}</span>
                    </a>
                    <div className={`header-notify ${show ? "show" : ""}`}>
                      {<StaffCampusSafetyAlert setCount={handleCountChange} />}
                    </div>
                  </li>
                </>
              )}

            {((currentRole === UserRole.Staff) || (currentRole === UserRole.Faculty) || (currentRole === UserRole.Student)) && (
              <li className="message">
                <a
                  onClick={() => navigate(ROUTER_URL.NOTIFICATION)}
                  title="Notification"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 9.5H17"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 14.5H14"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {notViewedCount > 0 ? (
                    <span className="notification-count">
                      {notViewedCount}
                    </span>
                  ) : null}
                </a>
              </li>
            )}

            {((currentRole == UserRole.Staff) || (currentRole == UserRole.Faculty)) && (
              <li className="notification">
                <a
                  onClick={() =>
                    navigate(
                      currentRole === UserRole.Staff
                        ? ROUTER_URL.STAFF_CONNECT
                        : ROUTER_URL.FACULTY_CONNECT
                    )
                  }
                  title="Communication"
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.818 15.752C19.818 16.0799 19.7452 16.4169 19.5903 16.7448C19.4355 17.0727 19.2351 17.3824 18.9709 17.6739C18.5246 18.1658 18.0327 18.521 17.4771 18.7487C16.9306 18.9765 16.3385 19.0949 15.7009 19.0949C14.7718 19.0949 13.779 18.8763 12.7314 18.4299C11.6839 17.9836 10.6364 17.3824 9.59805 16.6264C8.55055 15.8613 7.5577 15.0142 6.6104 14.076C5.6722 13.1287 4.82509 12.1358 4.06906 11.0974C3.32215 10.059 2.72098 9.02063 2.28376 7.99135C1.84654 6.95295 1.62793 5.9601 1.62793 5.0128C1.62793 4.3934 1.73723 3.80134 1.95584 3.25482C2.17445 2.69918 2.52058 2.1891 3.00335 1.73366C3.5863 1.15981 4.22391 0.877441 4.89796 0.877441C5.153 0.877441 5.40805 0.932094 5.63576 1.0414C5.87259 1.1507 6.08209 1.31466 6.24605 1.55149L8.35927 4.53004C8.52323 4.75775 8.64164 4.96725 8.72362 5.16764C8.80559 5.35893 8.85114 5.55021 8.85114 5.72328C8.85114 5.94189 8.78738 6.16049 8.65986 6.36999C8.54144 6.57949 8.36838 6.7981 8.14977 7.01671L7.45751 7.7363C7.35731 7.8365 7.31177 7.95491 7.31177 8.10065C7.31177 8.17352 7.32088 8.23728 7.33909 8.31015C7.36642 8.38302 7.39374 8.43767 7.41196 8.49232C7.57592 8.79291 7.85829 9.18459 8.25907 9.65824C8.66896 10.1319 9.10618 10.6147 9.57983 11.0974C10.0717 11.5802 10.5454 12.0265 11.0281 12.4364C11.5018 12.8372 11.8934 13.1104 12.2031 13.2744C12.2487 13.2926 12.3033 13.3199 12.3671 13.3473C12.44 13.3746 12.5128 13.3837 12.5948 13.3837C12.7497 13.3837 12.8681 13.3291 12.9683 13.2289L13.6605 12.5457C13.8883 12.318 14.1069 12.1449 14.3164 12.0356C14.5259 11.9081 14.7354 11.8443 14.9631 11.8443C15.1361 11.8443 15.3183 11.8808 15.5187 11.9627C15.7191 12.0447 15.9286 12.1631 16.1563 12.318L19.1713 14.4585C19.4081 14.6225 19.5721 14.8138 19.6723 15.0415C19.7634 15.2692 19.818 15.4969 19.818 15.752Z"
                      stroke="#70367C"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M16.6568 7.25348C16.6568 6.70696 16.2287 5.86895 15.5911 5.1858C15.0081 4.5573 14.2339 4.06543 13.4688 4.06543"
                      stroke="#70367C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.8448 7.25354C19.8448 3.72847 16.9938 0.877441 13.4688 0.877441"
                      stroke="#70367C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </li>
            )}

            <li className="profile profile-drop" onClick={toggleUserProfile}>
              <a href="javascript:void(0)" title="Logout" id="quicklinks">
                <img
                  src={user?.image ? baseURL + user.image : ""}
                  alt=""
                  onError={(e) =>
                  (e.currentTarget.src =
                    "/assets/images/icon/DefaultImage.jpeg")
                  }
                />
              </a>
              <div
                id="quicklinkwrap"
                className={showUser ? "show" : ""}
                ref={userProfileRef}
              >
                {showUser && (
                  <UserProfile
                    setShowAlert={setShowAlert}
                    setAlertTitle={setAlertTitle}
                    setAlertType={setAlertType}
                    setShowConfirm={setShowConfirm}
                  />
                )}
              </div>
            </li>
          </ul>
        </div>
      </header>
      <SweetAlert
        show={showAlert}
        type={alertType}
        title={alertTitle}
        onConfirm={() => setShowAlert(false)}
        showCancel={false}
        showConfirm={showConfirm}
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  currentRole: state.userDetails.userProfileData?.currentRole,
  notViewedCount: state.notificationCount.notificationCounts?.notViewedCount,
  freshman: state.userDetails.userProfileData?.isFreshman,
  user: state.userDetails.userProfileData,
  toMailId: state.common.campusSafetyToMailId,
});

const mapDispatchToProps = {
  getToMailId: (emailBlockId: number) => getToMailId(emailBlockId),
  getNotificationsCount: () => getNotificationCount(),
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
